import React from 'react' 
import { Component } from 'react';  
import ArticleDetailsJsx from './articleDetails.jsx';

import axios from 'axios';
import {  baseURL } from '../../../../constants/applicationConstants.js'; 
import { Loader } from '../../../../components/common/loader/loader.jsx';
import { fetchArticleDataFromAPI } from '../../../../shared/helper.js';

export default class articleDetails extends Component {
     
    constructor(props) {
        super(props);
        this.state = {
            detailsData: null,
            similarArticle: [],
            isLoading:false
        }
    }


    fetchSimilarArticles = async (category) => {

        const similarArticles = await fetchArticleDataFromAPI(category,'',1,'',5);

        if(similarArticles?.data?.data?.body?.length > 0)
        {
            this.setState({ similarArticle: similarArticles?.data?.data?.body })
        }
    }


    onDataDetails = ( ) => {
        
        this.setState({ isLoading: true })

        const searchParams = new URLSearchParams(this.props.location.search);

        let apiUrl = `${baseURL}/expertByAreaArticleDetails`
        let isDraft = false;

        if (searchParams.has('draft')) {           

            apiUrl = `${baseURL}/draftArticle`
            isDraft = true;
            // Perform actions based on the presence of the 'draft' parameter
            // For example, you might want to fetch draft data or display a specific UI.
        } 
        
        
        
        
        axios.get(apiUrl, {
            params: {
              slug: this.props.match.params.id,
            }
          }).then(res => {    
            
                const postData = isDraft ? res.data?.data : res.data?.data;
                if(postData.length > 0)            
                {
                    
                    this.setState({ detailsData: postData[0], isLoading: false });        
                    this.fetchSimilarArticles(postData[0]?.['_embedded']?.['wp:term']?.[0]?.[0]?.slug);             
                }
                else
                {
                    window.location.href = '/404'
                }
                
            }).catch(err => {
                this.setState({ isLoading: false })
            })
    }


    componentDidMount = () => {
        
        this.onDataDetails();
        
    }


    render() {
        return (
            <div>
                <ArticleDetailsJsx
                 detailsData={this.state.detailsData}  
                 similarArticle={this.state.similarArticle}  
                 isLoading={this.isLoading}/>

                 {/* {JSON.stringify(this.state.detailsData)} */}

                    {this.state.isLoading && <Loader />}
            </div>
        )
    }
}